import type { UserProfile } from '../types'

export type Portal = 'miner' | 'leader' | 'gov' | 'admin' | 'unsupported'

/* Roles that supervise a cooperative. Everything else on the mining_ops tier
 * (safety_officer, spotter, project_manager, chief_security, data_analyst and
 * any custom role a super admin defines) is a team member and gets the miner
 * portal - the backend enforces the finer capability checks either way. */
const LEADER_ROLES = new Set(['team_leader', 'company'])

export function portalFor(user: UserProfile | null): Portal {
  if (!user) return 'unsupported'
  const role = (user.role ?? '').toLowerCase()
  const tier = (user.tier ?? '').toLowerCase()

  if (role === 'super_admin' || tier === 'platform') return 'admin'
  if (tier === 'government') return 'gov'
  if (LEADER_ROLES.has(role)) return 'leader'
  return 'miner'
}

export function roleLabel(user: UserProfile | null): string {
  const r = (user?.role ?? '').replace(/_/g, ' ')
  return r ? r.replace(/\b\w/g, (c) => c.toUpperCase()) : 'Member'
}

/* orgType only distinguishes the 'leader' portal - role alone can't (a
 * cooperative's leader and a company's leader both hold role 'company', see
 * LEADER_ROLES above), so a company-type org's sidebar used to say
 * "Cooperative portal" unconditionally, contradicting the org type shown
 * elsewhere on the same page. */
export function portalLabel(portal: Portal, orgType?: string): string {
  switch (portal) {
    case 'leader': return orgType === 'company' ? 'Company portal' : 'Cooperative portal'
    case 'miner': return 'Miner portal'
    case 'gov': return 'Regulator portal'
    case 'admin': return 'Admin portal'
    default: return 'SSM Zambia'
  }
}
